import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { PaginationInput, PaginationPageEvent, ListParams, Res, NotificationData } from 'src/app/models';
import { LanguageService, DialogModalService, NotificationService, ApiNotificationsService } from 'src/app/services';
import { NotificationsChannelsSettingsActionsComponent } from 'src/app/components/dialog';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';

@Component({
  selector: 'app-notifications-channel-settings',
  templateUrl: './notifications-channel-settings.component.html',
  styleUrls: ['./notifications-channel-settings.component.css']
})
export class NotificationsChannelSettingsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  notification_id: string;
  notifications: NotificationData[] = [];

  constructor(
    public ngProgress: NgProgress,
    private notificationsService: ApiNotificationsService,
    private languageService: LanguageService,
    private dialogModal: DialogModalService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getList(): void {


    this.progressRef.start();
    this.loading = true;
    this.notifications = [];

    this.setListParams();

    this.notificationsService.getListNotificationsByChannel(this.listParams).subscribe((response: Res) => {
      console.log("RESPONSE_LIST_CHANNEL: ", response)

      if (response != null && response.result != null) {

        this.notifications = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
       
      },
      object: 'notifications',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }


  /**
   * 
   * @param ids 
   */
   onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.notificationsService.deleteNotificationsChannel({ id: ids }).subscribe(response => { console.log('[RESPONSE] deletePrice: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
   deleteSelected(): void {

    let ids = [...new Set(this.notifications.filter(val => val.checked).map(({ id }) => id))];
    this.onConfirm(ids);
  }

  /**
   * 
   */
   actionWithChannelSettings(id: any): void {

    let data = {
      notifications_id: id
    }

    this.dialogModal.open(data, NotificationsChannelsSettingsActionsComponent).then(
      (result) => {
      
        if (result) {
          
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.notifications[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.notifications.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.notifications.length == 0) return false;

    return this.notifications.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.notifications.length;
    let pc = this.notifications.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.notifications.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

   /**
   * 
   * @param event 
   */
    pageEvent(event: PaginationPageEvent): void {

      this.paginationOutput = event;
      this.getList();
    }


}
